<template>
  <AddPackage />
</template>
<script>
import appConfig from '@/app.config'
import AddPackage from '../../../components/mooc/packages/AddPackage.vue'
export default {
  page: {
    title: 'ثبت دوره جامع',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-add-packages',
  components: {
    AddPackage,
  },
}
</script>
